/* src/app/admin-dashboard/kiosk-tablets/kiosk-tablets.component.css */
.kt-wrap {
  padding: 24px 28px;
  max-width: 1100px;
  margin: 0 auto;
}
.kt-header h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}
.kt-header .sub {
  margin: 4px 0 20px;
  color: #6b7280;
  font-size: 14px;
}
.loading {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #6b7280;
}
.empty {
  color: #6b7280;
  padding: 24px 0;
}
.kt-msg {
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 14px;
}
.kt-msg.ok {
  background: #ecfdf5;
  color: #065f46;
}
.kt-msg.err {
  background: #fef2f2;
  color: #991b1b;
}
.kt-list {
  display: grid;
  gap: 16px;
}
.kt-card {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px 18px;
  background: #fff;
}
.kt-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}
.kt-name {
  font-size: 18px;
  font-weight: 600;
}
.kt-meta {
  color: #6b7280;
  font-size: 13px;
  margin-top: 2px;
}
.kt-state {
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}
.kt-state.ok {
  background: #ecfdf5;
  color: #065f46;
}
.kt-state.warn {
  background: #fffbeb;
  color: #92400e;
}
.kt-state.bad {
  background: #fef2f2;
  color: #991b1b;
}
.kt-facts {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
  margin: 12px 0;
  font-size: 14px;
  color: #374151;
}
.kt-pending {
  margin: 0 0 12px;
  font-size: 13px;
  color: #92400e;
}
.kt-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.kt-hint {
  margin: 10px 0 0;
  font-size: 13px;
  color: #6b7280;
}
.kt-warn {
  margin: 0 0 12px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #fffbeb;
  color: #92400e;
  font-size: 13px;
}
/*# sourceMappingURL=kiosk-tablets.component.css.map */
